import React from "react";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import { useSelector } from "react-redux";

const CoreIAicon = () => {
  const colorPrimary = useSelector((state) => state.app.primaryColor);

  return (
    <small style={{ color: colorPrimary }} className="text-xs">
      <AutoAwesomeIcon fontSize="small" />
      Ai
    </small>
  );
};

export default CoreIAicon;
